var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLikeV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.86 1.42126C4.66201 1.42126 1.9375 3.93077 1.9375 7.18998C1.9375 9.43838 2.9407 11.3313 4.27026 12.8994C5.59526 14.462 7.30472 15.7737 8.85012 16.8715L11.5165 18.7657C11.8085 18.9731 12.1915 18.9731 12.4835 18.7657L15.1499 16.8715C16.6953 15.7737 18.4047 14.462 19.7297 12.8994C21.0593 11.3313 22.0625 9.43838 22.0625 7.18998C22.0625 3.93077 19.338 1.42126 16.14 1.42126C14.4915 1.42126 13.0409 2.23247 12 3.2821C10.9591 2.23247 9.50849 1.42126 7.86 1.42126Z",
    stroke: "#1A1A1A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeV2);
export default __webpack_public_path__ + "static/media/like_v2.5a9a82f8d569bd86ba8805aa2ca5dfbe.svg";
export { ForwardRef as ReactComponent };